/*! GhostStat — shared Co-Pilot.  app.ghoststat.me/js/gs-copilot.js
 *
 * One Co-Pilot per plugin page. It renders as an off-canvas (markup: app/partials/copilot.php);
 * this script drops a small stars icon next to the plugin's <h1> and opens the panel on click.
 *
 *   1. Guide/insights — the panel shows the plugin's own one-liner. A plugin may replace it with a
 *      live read by calling GSCopilot.register(slug, fn) where fn(ctx) -> {paragraphs, observations}.
 *   2. Deep links — the T("cp.continue_in") links carry the current visitor/session/page context so the
 *      target opens the SAME visitor, and are Visitor-Intelligence-first.
 *
 * Dependency-free (uses Bootstrap's Offcanvas when present). No-ops when there is no Co-Pilot panel.
 */
(function (w, d) {
  function T(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  if (w.GSCopilot) return;

  var REG = {}; // slug -> builder fn(ctx) -> { paragraphs, observations }

  /* Identity/context we forward when jumping to a related report. */
  var CARRY = ["session", "session_id", "id", "visitor", "visitor_id", "page", "path",
               "country", "region", "city", "asn", "source", "campaign"];

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function ocEl() { return d.getElementById("gsCopilotOc"); }

  /* Carried params from the current URL, aliases normalised to what the pages expect. */
  function ctx() {
    var out = {}, p;
    try { p = new w.URLSearchParams(w.location.search); } catch (e) { return out; }
    CARRY.forEach(function (k) { var v = p.get(k); if (v) out[k] = v; });
    if (out.session_id && !out.session) out.session = out.session_id;
    if (out.visitor_id && !out.id) out.id = out.visitor_id;
    if (out.path && !out.page) out.page = out.path;
    return out;
  }

  function renderInsights() {
    var oc = ocEl(); if (!oc) return;
    var slug = oc.getAttribute("data-gscp-slug");
    var host = oc.querySelector('[data-gscp="insights"]');
    var fn = REG[slug];
    if (!host || typeof fn !== "function") return; // keep the server guide line when no builder
    var r; try { r = fn(ctx()) || {}; } catch (e) { return; }
    var html = "";
    (r.paragraphs || []).forEach(function (p) { html += '<p class="gs-cp-oc-p">' + esc(p) + "</p>"; });
    if (r.observations && r.observations.length) {
      html += '<div class="gs-cp-oc-obshead">'+T('cp.what_stands_out')+'</div>';
      r.observations.forEach(function (o) {
        html += '<div class="gs-cp-oc-obs"><i class="bi bi-lightbulb"></i><span>' + esc(o) + "</span></div>";
      });
    }
    if (html) host.innerHTML = html;
  }

  /* Rewrite the T("cp.continue_in") hrefs so navigation (and middle-click) carries visitor/page context.
     The existing ?site= is preserved; context params are added. */
  function updateLinks() {
    var oc = ocEl(); if (!oc) return;
    var c = ctx();
    oc.querySelectorAll("[data-gscp-to]").forEach(function (a) {
      var url; try { url = new w.URL(a.getAttribute("href"), w.location.origin); } catch (e) { return; }
      Object.keys(c).forEach(function (k) { if (c[k]) url.searchParams.set(k, c[k]); });
      if (w.GS && GS.site && !url.searchParams.get("site")) url.searchParams.set("site", GS.site);
      a.setAttribute("href", url.pathname + url.search);
    });
  }

  function openOc() {
    var oc = ocEl(); if (!oc) return;
    updateLinks();
    renderInsights(); // recompute from the plugin's current data each time it opens
    if (w.bootstrap && w.bootstrap.Offcanvas) w.bootstrap.Offcanvas.getOrCreateInstance(oc).show();
  }

  /* Put the stars trigger inside the plugin's first <h1>. Idempotent, and re-run on init so a page
     that rewrites its title still gets the icon back. */
  function injectTrigger() {
    if (!ocEl()) return;
    var main = d.querySelector("main.gs-main") || d.body;
    var h1 = main ? main.querySelector("h1") : null;
    if (!h1 || h1.querySelector(".gs-cp-trigger")) return;
    var b = d.createElement("button");
    b.type = "button";
    b.className = "gs-cp-trigger";
    b.title = T("cp.copilot");
    b.setAttribute("aria-label", T("cp.open_for_page"));
    b.innerHTML = '<i class="bi bi-stars" aria-hidden="true"></i>';
    b.addEventListener("click", function (e) { e.preventDefault(); openOc(); });
    h1.appendChild(b);
  }

  function init() {
    if (!ocEl()) return;
    injectTrigger();
    renderInsights();
  }

  var GSCopilot = {
    register: function (slug, fn) { if (slug && typeof fn === "function") { REG[String(slug)] = fn; renderInsights(); } },
    refresh: init,
    open: openOc,
    ctx: ctx
  };
  w.GSCopilot = GSCopilot;

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", init); else init();
  d.addEventListener("gs:ready", init);
  d.addEventListener("gs:site-change", init);
})(window, document);
